<template>
  <div class="ly-c-login">
    <img class="plat-logo" :src="platLogo" v-if="platLogo" />
    <div class="form-login">
      <!-- 7.4vh 0 7.9vh 0 -->
      <div class="login-position">
        <div class="form-body">
          <div class="ly-c-flex logo-flex">
            <img class="logo_img" :src="logoImg" />
            <p class="login-title">
              <span>欢迎您登录</span>
            </p>
          </div>
          <div class="login-tips">
            提示：外部用户请输入账号密码登录；内部用户请点击IAM单点登录。如您没有当前系统使用权限，请联系中化信息IT服务中心申请权限！联系方式：邮箱：itsm@sinochem.com;电话：010-59568666
          </div>
          <div class="login-content">
            <div class="qrcode-login">
              <p class="qrcode-title">手机扫码，安全登录</p>
              <div
                class="qrcode-border"
                :class="qrcodeError ? 'is-disabled' : ''"
              >
                <!-- is-disabled -->
                <img :src="qrcode" class="code-img" />
                <div class="disabled-content">
                  <img class="qrcode-missed" :src="qrcodeMissedImg" />
                  <p class="missed-text">二维码已失效</p>
                  <p class="refresh-btn" @click="getAuthQr">点击刷新</p>
                </div>
              </div>
              <p class="remark">请使用化小易移动端扫描二维码</p>
            </div>
            <el-form
              ref="loginForm"
              :model="loginForm"
              :rules="rules"
              class="login-form-input"
            >
              <line-tabs
                class="ly-c-tabs-body"
                v-model="loginType"
                :tabs="loginTypeList"
                @tab-change="loginTypeChange"
              ></line-tabs>
              <!-- 账号密码登录 -->
              <template v-if="['account', 'iam'].includes(loginType)">
                <el-form-item label="" prop="username">
                  <el-input
                    v-model.trim="loginForm.username"
                    placeholder="请输入用户名"
                    maxlength="32"
                  />
                </el-form-item>
                <el-form-item label="" prop="password">
                  <el-input
                    v-model.trim="loginForm.password"
                    type="password"
                    show-password
                    placeholder="请输入密码"
                    maxlength="32"
                  />
                </el-form-item>
                <el-form-item label="" prop="code" class="code-input">
                  <el-input
                    v-model.trim="loginForm.code"
                    placeholder="请输入验证码"
                    maxlength="32"
                    @keydown.enter.native="loginInfo('loginForm')"
                  />
                  <div class="login-code" @click="getCodeImg">
                    <el-image :src="codeUrl">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </div>
                </el-form-item>
              </template>
              <!-- 手机号登录 -->
              <template v-if="loginType == 'phone'">
                <el-form-item label="" prop="phone">
                  <el-input
                    v-model.trim="loginForm.phone"
                    placeholder="请输入手机号"
                    maxlength="32"
                  />
                </el-form-item>
                <el-form-item label="" prop="code">
                  <el-input
                    v-model.trim="loginForm.code"
                    placeholder="请输入验证码"
                    maxlength="32"
                  >
                  </el-input>
                </el-form-item>
                <p
                  class="phone-code"
                  :class="countdown > 0 ? 'is-disabled' : ''"
                >
                  <span @click="getPhoneCode">{{
                    countdown > 0 ? countdown + "秒后重新获取" : "获取验证码"
                  }}</span>
                </p>
              </template>
              <el-checkbox
                class="remember-btn"
                v-model="rememberFlag"
                :true-label="1"
                :false-label="0"
                v-if="loginType == 'account'"
                >记住密码</el-checkbox
              >
              <el-form-item label="">
                <el-button
                  class="login-btn"
                  type="primary"
                  :loading="loginLoading"
                  @click="loginInfo()"
                  >登 录</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- <img
          class="other-img"
          :src="otherImg"
        /> -->
        <img class="other-img-border" :src="otherImg" />
      </div>
    </div>
    <div class="sys-title-body">
      <p class="small-title">
        {{
          sysBasicData && sysBasicData.sysOrgName ? sysBasicData.sysOrgName : ""
        }}
      </p>
      <p class="large-title">
        {{ sysBasicData && sysBasicData.sysName ? sysBasicData.sysName : "" }}
      </p>
      <p class="word">Smart</p>
      <p class="word">
        <!-- Intelligent Management Platform -->
        Management Platform
      </p>
    </div>
    <p class="copyright">版权所有©️中国中化控股有限责任公司</p>
  </div>
</template>

<script>
import utils from "../scripts/utils";
import validate from "../scripts/validate";
import request from "../scripts/request";
import auth from "../scripts/auth";
import Qs from "qs";
import { setRem } from "../scripts/rem.js";
import axios from "axios";
const Base64 = require("js-base64").Base64;
export default {
  props: {
    title: {
      type: String,
      default: "智慧管理中台",
    },
  },
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        grant_type: "captcha",
        code: "",
        uuid: "",
      },
      loginLoading: false,
      rules: {
        username: [
          {
            required: true,
            message: "请输入用户名",
            trigger: ["blur"],
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: ["blur"],
          },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: ["blur"],
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: ["blur"],
          },
        ],
      },
      rememberFlag: 0,
      logoTitle: "中国中化智慧管理中台",
      logoImg: "",
      qrcodeMissedImg: require("../assets/images/qrcode_disabled.svg"),
      otherImg: require("../assets/images/login_other_icon.png"),
      platLogo: "",
      codeUrl: "",
      sysBasicData: null,
      qrcode: "", //化小易二维码
      qrToken: "",
      qrcodeError: false,
      loginType: "account",
      phoneUuid: "",
      timer: null,
      countdown: 0,

      loginTypeList: [
        {
          label: "账号登录",
          value: "account",
        },
        {
          label: "短信登录",
          value: "phone",
        },
        {
          label: "IAM单点登录",
          value: "iam",
        },
      ],
    };
  },
  created() {
    if (auth.getToken()) {
      auth.removeToken();
    }
    this.getCodeImg();
    this.getAuthQr();
    if (process.env.VUE_APP_KEY != "portal") {
      this.loginTypeList.pop();
    }
  },
  mounted() {
    setRem();
    window.onresize = function () {
      setRem();
    };
  },
  destroyed() {
    document.documentElement.style["font-size"] = "14px";
  },
  methods: {
    loginTypeChange(item, index) {
      this.loginForm.code = "";
      if (this.$refs.loginForm) {
        this.$refs.loginForm.clearValidate();
      }
      if (item.value == "iam") {
        // let open_url =
        //   window.location.origin + process.env.VUE_APP_PUBLIC_PATH + "/#/";
        // let redirect_uri = `${open_url}?ifcp_url=${Base64.encode(open_url)}`;
        // let url =
        //   process.env.VUE_APP_IAM_API +
        //   "/idp/authCenter/authenticate?client_id=IFCP&response_type=code&state=1&redirect_uri=" +
        //   encodeURIComponent(redirect_uri);
        // window.location.href = url;
        let tenantCode = process.env.VUE_APP_TENANT;
        let base_url = `${window.location.origin}${process.env.VUE_APP_PUBLIC_PATH}/#/`;
        let open_url = `${window.location.origin}${
          process.env.VUE_APP_CODE
        }/${tenantCodeEncode(tenantCode)}#/`;
        let redirect_uri = `${base_url}?ifcp_url=${Base64.encode(open_url)}`;
        let url =
          process.env.VUE_APP_IAM_API +
          "/idp/authCenter/authenticate?client_id=IFCP&response_type=code&state=1&redirect_uri=" +
          encodeURIComponent(redirect_uri);
        window.location.href = url;
      } else if (item.value == "account") {
        let rememberFlag = auth.getPlatLocalStorage("rememberAccount");
        this.rememberFlag = rememberFlag ? rememberFlag : 0;
        if (this.rememberFlag) {
          let accountInfo = auth.getPlatLocalStorage("account");
          this.loginForm.username = accountInfo.username;
          this.loginForm.password = utils.doDecrypt(accountInfo.password);
        }
      }
    },
    /**-----------账号密码登录 Start------------**/
    /**获取验证码 */
    getCodeImg() {
      request({
        url: "/captcha",
        method: "get",
      }).then((res) => {
        if (res.code === "00000") {
          if (res.data) {
            this.codeUrl = "data:image/png;base64," + res.data.img;
            this.loginForm.uuid = res.data.uuid;
          }
        }
      });
    },
    /**账号密码登录 */
    loginInfo() {
      if (auth.getToken()) {
        auth.removeToken();
      }
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          this.loginLoading = true;
          let data = { ...this.loginForm };
          if (this.loginType == "account") {
            data.grant_type = "captcha";
            data.password = utils.doEncrypt(data.password);
          } else if (this.loginType == "phone") {
            data.grant_type = "sms";
            data["uuid"] = this.phoneUuid;
          }
          this.commonLogin(data);
        } else {
          return false;
        }
      });
    },
    /**-----------账号密码登录 End------------**/

    /**-----------扫码登录 Start------------**/
    /** 获取化小易二维码*/
    getAuthQr() {
      this.qrToken = "";
      // this.qrcode = "";
      this.qrcodeError = false;
      request({
        url: process.env.VUE_APP_QRCODE_API + "/authn/authn/getAuthQr",
        method: "post",
        data: {
          entityId: "IFCP",
        },
        errorType: "allMsg",
        noMsgCode: [-1],
      })
        .then((res) => {
          if (res.status === 200) {
            this.qrcode = res.qrMsg;
            this.qrToken = res.qrToken;
            // this.getAuthChainCode();
            this.qrcodeLogin();
          } else {
            this.$message.error({
              message: "获取二维码失败",
            });
          }
        })
        .catch((error) => {
          this.$message.error({
            message: "获取二维码失败",
          });
        });
    },
    /**扫码登录 */
    qrcodeLogin() {
      let data = {
        code: this.qrToken,
        grant_type: "qr_iam",
      };
      this.commonLogin(data, "qrcode");
    },
    /**-----------扫码登录 End------------**/

    /**-----------短信验证码登录 Start------------**/
    /**获取短信验证码 */
    getPhoneCode() {
      let phoneReq = validate.phonePattern();
      let flag = phoneReq.test(this.loginForm.phone);
      if (!this.loginForm.phone) {
        this.$message.error({
          message: "请输入手机号",
        });
      } else if (!flag) {
        this.$message.error({
          message: "请输入正确手机号",
        });
      } else {
        if (!this.timer) {
          this.countdown = 60;
          this.timer = setInterval(() => {
            if (this.countdown > 0) {
              this.countdown--;
            } else {
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }

        let data = {
          phone: this.loginForm.phone,
        };
        request({
          url: "/auth/sms-code",
          method: "post",
          data: Qs.stringify(data),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }).then((res) => {
          if (res.code === "00000") {
            this.phoneUuid = res.data.uuid;
          }
        });
      }
    },
    /**-----------短信验证码登录 End------------**/
    /**登录通用方法
     *@param {*} loginType 登录方式
     */
    commonLogin(data, loginType = "account") {
      request({
        url: "/auth/oauth/token",
        method: "post",
        data: Qs.stringify(data),
        headers: {
          Authorization: "Basic YWRtaW4td2ViOlVWTVI5a1UwVDdQeVBrREV3bUNv",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        otherToken: true,
        noMsgCode: loginType == "qrcode" ? [400] : [],
      })
        .then((res) => {
          // this.loginLoading = false;
          if (res.code === "00000") {
            if (res.data) {
              let userInfo = {
                id: res.data.userId,
                userUuid: res.data.userUuid,
                username: res.data.username,
                account: res.data.account,
              };
              auth.setUserInfo(userInfo);

              auth.saveToken(res.data.access_token);
              //储存登录时间点，过期时间等
              let loginInfo = {
                refresh_token: res.data.refresh_token,
                expiresTime: res.data.expires_in,
                loginTime: new Date().getTime(),
              };

              if (loginType == "account") {
                let rememberAccount = {
                  username: data.username,
                  password: data.password,
                };
                auth.setPlatLocalStorage("rememberAccount", this.rememberFlag);
                if (this.rememberFlag) {
                  auth.setPlatLocalStorage("account", rememberAccount);
                } else {
                  auth.removePlatLocalStorage("account");
                }
              }
              auth.saveLoginInfo(loginInfo);
              this.$emit("login", res);
              // this.loginLoading = false;
            } else {
              this.loginLoading = false;
              this.$message.error({
                message: "获取登录信息失败",
              });
            }
          } else {
            this.loginLoading = false;
            if (loginType == "account") {
              this.getCodeImg();
            }
          }
        })
        .catch((error) => {
          if (loginType == "account") {
            this.getCodeImg();
          } else if (loginType == "qrcode") {
            this.qrcodeError = true;
            let data = error.data || null;
            let msg = data ? data.msg : "系统异常";
            if (!data || data.code != "A0232") {
              this.$alert(msg, "系统提示", {
                confirmButtonText: "确定",
                callback: (action) => {},
              });
            }
          }
          this.loginLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  -webkit-user-drag: none;
}
/deep/.el-image__inner {
  -webkit-user-drag: none;
}
/**布局文件*/
.ly-c-login {
  width: 100vw;
  height: 100vh;
  background: url("../assets/images/login_bag.png") no-repeat;
  background-size: 100% 100% !important;
  position: relative;
  .copyright {
    position: absolute;
    left: 0;
    bottom: 5%;
    width: 100%;
    opacity: 0.41;
    // font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #acbbce;
    letter-spacing: 20px;
    text-align: center;
    font-weight: 400;
  }
  .plat-logo {
    left: 8.2%;
    position: absolute;
    // bottom: 91%;
    top: 7%;
    width: 7.375rem;
    height: auto;
  }
  .text_img {
    position: absolute;
    top: 70px;
    left: 100px;
    width: 303px;
    height: auto;
    color: #fff;
  }
  .sino_img {
    position: absolute;
    bottom: 72px;
    left: 100px;
    color: #fff;
  }
  .sys-title-body {
    position: absolute;
    // left: 67.8%;
    left: 68.125%;
    top: 39.37%;
    .small-title {
      // font-size: 50px;
      font-size: 3.125rem;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 700;
      margin-bottom: 12px;
      margin-left: -4px;
    }
    .large-title {
      font-size: 4.375rem;
      // font-size: 70px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 700;
      margin-bottom: 30px;
      margin-left: -3px;
    }
    .word {
      // font-size: 20px;
      font-size: 1.25rem;
      color: #529be3;
      letter-spacing: 8.33px;
      line-height: 40px;
      font-weight: 400;
      opacity: 0.56;
    }
  }
  .login-position {
    position: relative;
    width: 100%;
    // padding: 4.44vh 6.25vw 9vh 6.25vw;
    padding: 4.44vh 2.5vw 9vh 2.5vw;
    // padding: 7.4vh 0 9vh 0;
  }
  @media screen and (min-width: 1280px) and (max-width: 1366px) {
    .login-position {
      padding: 5.4vh 2.5vw 5.9vh 2.5vw;
    }
  }
  .form-login {
    width: 56.25%;
    background: #fff;
    box-shadow: 0px 30px 60px 10px rgba(25, 97, 168, 0.5);
    border-radius: 10px;
    position: absolute;
    left: 8.2%;
    top: 50%;
    transform: translate(0, -50%);
    .logo-flex {
      margin-bottom: 9.6vh;
    }
    .logo_img {
      width: 2.625rem;
      // width: 58px;
      height: auto;

      margin-right: 1rem;
    }
    .login-logo {
      height: auto;
      margin-bottom: 45px;
      .img {
        width: 34px;
        height: auto;
      }
      .sys-title {
        margin-left: 14px;
        font-size: 20px;
        font-weight: normal;
        color: #121d4e;
        height: 31px;
        line-height: 31px;
      }
    }
    .login-title {
      font-size: 2rem;
      color: #13225a;
      letter-spacing: 9.41px;
      font-weight: 500;
    }
    .other-img {
      width: 61px;
      height: auto;
      position: absolute;
      bottom: 75px;
      right: 6.5%;
    }
    .other-img-border {
      // width: 61px;
      // width: 118px;
      width: 7.6rem;
      height: auto;
      position: absolute;
      // bottom: 17%;
      // right: -30.5px;
      bottom: 6%;
      right: -3.8rem;
      // right: -59px;
      // box-shadow: 0px 20px 40px 0px rgba(20,95,174,1);
    }
    .form-body {
      width: 100%;
      // width: calc(100% - 20.5%);
      // margin-left: 20.5%;
    }
  }
  .login-content {
    width: 100%;
    padding: 0 3.75vw;
    display: flex;
  }
  .qrcode-login {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 8.85vw;
    .qrcode-title {
      font-size: 1.25rem;
      color: #13225a;
      letter-spacing: 0;
      font-weight: 500;
      text-align: center;
      margin-bottom: 4vh;
    }
    .qrcode-border {
      // width: 15rem;
      // height: 15rem;
      margin-bottom: 4.64vh;
      overflow: hidden;
      position: relative;
      // padding: 1.25rem;
      .code-img {
        width: 16rem;
        height: 16rem;
        // width: auto;
        // height: 24.24vh;
        border: 1px solid #bcc1d3;
        border-radius: 6px;
        -webkit-user-drag: none;
      }
      .disabled-content {
        display: none;
      }
      &.is-disabled {
        .disabled-content {
          background: rgba(255, 255, 255, 0.96);
          display: flex !important;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
      }
      .disabled-content {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        .qrcode-missed {
          width: 3rem;
          height: auto;
          margin-bottom: 1.21vh;
        }
        .missed-text {
          font-size: 1.125rem;
          color: #13225a;
          letter-spacing: 0;
          font-weight: 500;
          margin-bottom: 0.8vh;
        }
        .refresh-btn {
          font-size: 1.125rem;
          color: #0258e7;
          letter-spacing: 0;
          font-weight: 400;
          cursor: pointer;
        }
      }
    }
    .remark {
      opacity: 0.5;
      font-size: 1rem;
      color: #101e30;
      letter-spacing: 0;
      font-weight: 400;
    }
  }
  .login-form-input {
    min-height: 39.5vh;
    &.el-form {
      width: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .el-form-item {
        margin-bottom: 2.8vh;
        width: 100%;
        &.code-input {
          /deep/.el-form-item__content {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .el-input {
              flex: 3;
              // width: 168px;
              .el-input__inner {
                width: 100% !important;
              }
            }
            .login-code {
              flex: 2;
              // width: 117px;
              // height: 56px;
              height: 4.84vh;
              margin-left: 0.62vw;
              background: rgba(218, 222, 239, 0.36);
              text-align: center;
              cursor: pointer;
              overflow: hidden;
              .el-image {
                width: 100%;
                height: 100%;
              }
            }
          }
          /deep/.el-form-item__content {
            padding: 0 !important;
            line-height: inherit !important;
            &::before {
              display: none;
            }
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
        /deep/.el-form-item__content,
        /deep/.el-input__icon {
          line-height: 4.8vh;
        }
        :deep(.el-input__inner) {
          width: 100%;
          height: 4.8vh;
          line-height: 4.8vh;
          // background: #eff3f9;
          border: 1px solid #dbdee0;
          border-radius: 6px;
        }
        input {
          &::-webkit-input-placeholder {
            /* WebKit browsers */
            color: rgba(0, 0, 0, 0.36);
          }
          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: rgba(0, 0, 0, 0.36);
          }
          &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: rgba(0, 0, 0, 0.36);
          }
          &:-ms-input-placeholder {
            /* Internet Explorer 10+ */
            color: rgba(0, 0, 0, 0.36);
          }
        }
        .el-button {
          &.login-btn {
            width: 100%;
            height: 5.5vh;
            line-height: 5.5vh;
            padding: 0;
            // line-height: 5.5vh;
            // height: 60px;
            color: #fff;
            border: 0;
            // font-size: 18px;
            font-size: 1.125rem;
            font-weight: 500;
            background: #1961a8 !important;
            // background: linear-gradient(333deg, #2d4cd3 0%, #5474fe 100%);
            // box-shadow: 0px 16px 41px 4px rgba(45, 76, 211, 0.24);
            border-radius: 8px;
          }
        }
      }
      .remember-btn {
        width: 100%;
        // margin-bottom: 3.6vh;
        margin-bottom: 2.5vh;
        /deep/.el-checkbox__label {
          font-weight: normal;
        }
      }
      /deep/.el-form-item__error {
        .el-input__icon {
          line-height: 1;
        }
      }
    }
  }
}
/deep/.line-tabs {
  padding: 0;
  margin-bottom: 2.4vh;
}
/deep/.tab-body {
  width: 100%;
}
/deep/.tab-content {
  // justify-content: space-between;
  justify-content: space-around;
  width: 100%;
  .tabs {
    padding: 0 0 10px 0 !important;
    user-select: none;
    font-size: 1.25rem !important;
    &.is-active {
      &.bottom-line {
        border-bottom: 2px solid #0258e7 !important;
      }
    }
  }
}
.phone-code {
  margin-bottom: 4.04vh;
  width: 100%;
  text-align: right;
  &.is-disabled {
    span {
      color: #101e30;
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
  span {
    user-select: none;
    color: #0e44a8;
    cursor: pointer;
  }
}
.remember-btn {
  /deep/.el-checkbox__label {
    padding-left: 6px;
    color: #101e30 !important;
  }
  /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #1961a8 !important;
    border-color: #1961a8 !important;
  }
  /deep/.el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #1961a8 !important;
  }
  /deep/.el-checkbox__inner:hover {
    border-color: #1961a8 !important;
  }
}
.login-tips {
  // text-align: right;
  line-height: 20px;
  padding: 0 3.75vw;
  margin-bottom: 1vh;
  color: #f56c6c;
}
</style>
